<template>
	<div v-if="renderList.length > 0 && submitData.length > 0">
		<el-form ref="form" :validate-on-rule-change="false" label-position="top" :class="$style.form" autocomplete="off">
			<div v-for="(item, index) in renderList" :class="$style.renderList">
				<div>
					<p class="title">{{ item.title }} </p>
					<div class="verticalDivider"></div>
					<el-form-item ref="discountValidate" :prop="`discount${index}`" :rules="discountRules"
						:class="[index === 0 ? $style.firstItem : $style.afterFirstItem]">
						<div :class="$style.inputDisplay">
							<span>折扣金額</span>
							<el-input v-model.number="submitData[index]['discount']" class="isStyleText is-border bg-white"
								min="0" type="number" @blur="emitSubmitData(index)">
							</el-input>
						</div>
					</el-form-item>
					<el-form-item>
						<div :class="$style.inputDisplayUnit">
							<span>折扣單位</span>
							<div class="unitRadio">
								<el-radio v-model="submitData[index]['discountType']" label="fixed"
									@input="changeRadio(index, 'fixed')">元</el-radio>
								<el-radio v-model="submitData[index]['discountType']" label="%"
									@input="changeRadio(index, '%')">%
									off</el-radio>
							</div>
						</div>
					</el-form-item>
				</div>
				<el-button v-if="index === 0" @click="sameDiscount">將折扣套用至下方所有服務</el-button>
				<el-divider></el-divider>
			</div>
		</el-form>
	</div>
</template>

<script>
import { cloneDeep } from 'lodash'
export default {
	name: 'FormItemGroup',
	data() {
		return {
			checked: false,
			submitData: cloneDeep(this.defaultValue),
			radio: 'fixed',
			continueChangeTab: true,
			discountRules: [
				{ type: 'number', message: '請輸入有效數字', trigger: ['blur', 'change'] },
				{ validator: this.validateDiscount, trigger: ['blur', 'change'] },
			],
			index: 0,
		};
	},
	inject: ['dbData', 'isEdit'],
	props: {
		renderList: {
			type: Array,
			default: () => []
		},
		type: {
			type: String,
			default: ''
		},
		defaultValue: {
			type: Array,
			default: () => {
				return []
			}
		}
	},
	watch: {
		submitData: {
			handler(nvl) {

			},
			deep: true
		},
		continueChangeTab(nvl) {
			this.$emit('continueChangeTab', nvl)
		}
	},
	computed: {

	},
	created() { },
	mounted() {
	},
	methods: {
		/**
		 * @description 如果是fixed的規則
		 */
		validateDiscount(rule, value, callback) {
			try {
				const { discountType, discount } = this.submitData[this.index]
				if (typeof (discount) === 'string') {
					callback(new Error('折扣金額需大於等於0'));
				}
				if (discountType === '%') {
					if (discount >= 0 && discount <= 100) {
						callback();
					} else {
						callback(new Error('折扣金額需大於等於0且小於等於100'));
					}
				} else if (discountType === 'fixed') {
					if (discount >= 0) {
						callback();
					} else {
						callback(new Error('折扣金額需大於等於0'));
					}
				}
			} catch (error) {
				console.error(error.message)
			}
		},
		changeRadio(index, type) {
			try {
				this.index = index
				if (type === '%') {
					if (typeof (this.submitData[index].discount) === 'string' ||
						(typeof (this.submitData[index].discount) === 'number' && this.submitData[index].discount > 100)) {
						this.submitData[index].discountType = 'fixed'
						return
					}
				}
				if (this.$refs.form) {
					this.$nextTick(() => {
						this.$refs.form.validateField(`discount${index}`)
					})
				}
				this.emitSubmitData(index)
			} catch (error) {
				console.error(error.message)
			}

		},
		/**
		 * @description 將資料發送給父層
		 */
		emitSubmitData(index) {
			try {
				if (typeof (index) === 'number') {
					this.index = index
				}

				this.$emit('updateSubmitData', {
					submitData: this.submitData ? this.submitData : [],
					type: this.type
				})
			} catch (error) {
				console.error(error.message)
			}

		},
		/**
		 * @description 將折扣套用至下方所有服務
		 */
		sameDiscount() {
			try {
				let submitDataKeys = Object.keys(this.submitData[0]).filter(item => (item !== 'id' && item !== 'type' && item !== 'groupAlias'))
				for (let i = 1, len = this.submitData.length; i < len; i++) {
					submitDataKeys.forEach(key => {
						this.submitData[i][key] = this.submitData[0][key]
					})
				}
				this.emitSubmitData()
			} catch (error) {
				console.error(error.message)
			}

		},
	},
	components: {},
};
</script>

<style lang="scss" module>
.form {
	:global {
		.el-form-item__label {
			width: 145px;
		}

		.el-form-item__label {
			padding-left: 5px;
			padding-right: 5px;
		}

		.el-form-item {
			display: flex;
			justify-content: flex-start;
			align-items: flex-end;
		}

		.el-form-item__content {
			display: flex;
			justify-content: flex-start;
			flex-grow: 1;

			>span {
				margin-left: 10px;
				margin-right: 10px;
			}
		}

		.el-input-group__prepend {
			padding-left: 0;
		}

		.el-input-group__append {
			background-color: $color-line;
			border-radius: 0 5px 5px 0;
		}

		.el-input {
			&.isStyleText {
				.el-input-group__append {
					background: transparent;
					border-radius: 0;
					border-left: 0;
				}

				.el-input__inner {
					border-radius: 5px;
				}
			}
		}
	}
}

.inputDisplayUnit {
	display: flex;
	flex-direction: column;
	margin-left: 10px;
	flex-grow: 1;

	:global {
		.unitRadio {
			width: 175px;
		}

		display: flex;
		justify-content: flex-start;
	}
}

.inputDisplay {
	display: flex;
	flex-direction: column;
	margin-left: 10px;
	flex-grow: 1;
	width: 100%;

	:global {
		display: flex;
		justify-content: flex-start;
	}
}

.renderList {

	display: flex;
	flex-direction: column;
	align-items: flex-end;

	>div {
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		position: relative;
	}

	:global {
		.title {
			width: 130px;
			margin-top: 30px;
		}

		.verticalDivider {
			border-left: 1px solid #000;
			/* 设置直线的样式 */
			height: 30px;
			/* 设置直线的高度 */
			width: 1px;
			margin-left: 10px;
			margin-right: 10px;
			margin-top: 15px;
		}

		.el-button {
			border-radius: $border-radius;
			width: 80%;
		}
	}

	// &:first-child {
	// 	align-items: flex-end;
	// }


}

.rightFirstContent {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-grow: 1;
}

.rightContent {
	display: flex;
	justify-content: flex-start;
	align-items: flex-end;
	flex-grow: 1;
}

.firstItem {
	display: flex;
	align-items: center;
	width: 60%;
}

.afterFirstItem {
	align-items: flex-end;
	width: 60%;
}
</style>
